import { Box, Checkbox, FormControlLabel, IconButton } from "@mui/material";
import { palette } from "../../themes/theme";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addSelectedLayer,
  removeSelectedLayer,
} from "../../redux/slices/mapSlice";
import SettingsIcon from "@mui/icons-material/Settings";
import { MapToolboxContext } from "../../context/mapToolbox/mapToolbox.provider";
// import { mapFeatureLayer, mapRoadLayer } from "../../utils/helper";

const ExpandMoreCheckBox = ({
  label,
  showMore,
  onClickShowMore,
  onCheckClick,
  dataVisible,
  checked,
  disabled,
}) => {
  //   console.log("disabled", label, disabled);
  const title = label.split(",");
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        // background: palette.background.light,
        px: 1,
        opacity: !disabled ? 1 : 0.4,
      }}
    >
      <FormControlLabel
        disabled={disabled}
        control={<Checkbox onChange={onCheckClick} checked={checked} sx={{color: palette.primary.main}} />}
        label={
          <span style={{ fontSize: "1.6vh" }}>
            {title[0]}
            <span style={{ opacity: 0.5 }}>{title[1] && `, ${title[1]}`}</span>
          </span>
        }
      />
      {showMore && (
        <IconButton onClick={onClickShowMore}>
          {label === "Highways" ? (
            <SettingsIcon fontSize="medium" color="primary" />
          ) : dataVisible ? (
            <RemoveIcon fontSize="medium" color="primary" />
          ) : (
            <AddIcon fontSize="medium" color="primary" />
          )}
        </IconButton>
      )}
    </Box>
  );
};

const AdditionalLayers = ({ mapRef, mapFeatureLayer, mapRoadLayer }) => {
  const { showHighwayStyle, setShowHighwayStyle } =
    useContext(MapToolboxContext);
  const configureData = (data) =>
    data.map((layer) => ({
      ...layer,
      showMore: false,
      enable: false,
      values: layer.values.map((d) => ({ ...d, enable: false })),
    }));

  const dispatch = useDispatch();
  const selectedLayers = useSelector(
    (state) => state.map.layers.selectedLayers
  );

  const highwayLayers = mapRoadLayer
    .flatMap((d) => d.values.flatMap((x) => x.id).filter((x) => !x.disable))
    .filter((d) => !d.disable);
  const mapFeatures = mapFeatureLayer
    .flatMap((d) => d.values.flatMap((x) => x.id).filter((x) => !x.disable))
    .filter((d) => !d.disable);
  const [showMoreHighwayFeatures, setShowMoreHighwayFeatures] = useState(false);
  const [showMoreMapFeatures, setShowMoreMapFeatures] = useState(false);
  const [mapRoadLayerState, setMapRoadLayerState] = useState();
  const [mapFeatureLayerState, setMapFeatureLayerState] = useState();

  useEffect(() => {
    setMapFeatureLayerState(configureData(mapFeatureLayer));
    setMapRoadLayerState(configureData(mapRoadLayer));
  }, [mapFeatureLayer, mapRoadLayer]);

  if (!mapFeatureLayer || !mapRoadLayer) return null;

  const setLayoutVisibility = (ids, value) => {
    if (!value) {
      ids.forEach((id) => mapRef.setLayoutProperty(id, "visibility", "none"));
      dispatch(removeSelectedLayer(ids));
      return;
    }
    ids.forEach((id) => mapRef.setLayoutProperty(id, "visibility", "visible"));
    dispatch(addSelectedLayer(ids));
  };

  const showHighway = () => {
    if (highwayLayers.every((d) => selectedLayers.includes(d))) {
      setLayoutVisibility(highwayLayers);
      return;
    }
    setLayoutVisibility(highwayLayers, true);
  };

  const showMapFeatures = () => {
    if (mapFeatures.every((d) => selectedLayers.includes(d))) {
      setLayoutVisibility(mapFeatures);
      return;
    }
    setLayoutVisibility(mapFeatures, true);
  };

  const enableParent = (array) => {
    const allIds = array.flatMap((d) => d.id);
    if (allIds.every((d) => selectedLayers.includes(d))) {
      setLayoutVisibility(allIds);
      return;
    }
    setLayoutVisibility(allIds, true);
  };

  const enableChild = (id) => {
    if (selectedLayers.includes(id)) {
      setLayoutVisibility([id]);
      return;
    }
    setLayoutVisibility([id], true);
  };

  const toggleShowMore = (key, setState) => {
    setState((layer) =>
      layer.map((d) => ({
        ...d,
        showMore: key === d.title ? !d.showMore : d.showMore,
      }))
    );
  };

  const toggleHighwayFeatures = () => {
    setShowMoreHighwayFeatures((d) => !d);
  };
  const toggleMapFeatures = () => {
    setShowMoreMapFeatures((d) => !d);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <ExpandMoreCheckBox
        label="Highway Features"
        showMore={true}
        dataVisible={showMoreHighwayFeatures}
        onClickShowMore={toggleHighwayFeatures}
        onCheckClick={showHighway}
        checked={highwayLayers.every((d) => selectedLayers.includes(d))}
      />
      {showMoreHighwayFeatures && (
        <Box
          sx={{
            pl: "1vw",
            display: "flex",
            flexDirection: "column",
            gap: "1vh",
            borderLeft: "1px solid white",
            borderRadius: "4px",
            maxHeight: "200px",
            overflow: "auto",
          }}
        >
          {mapRoadLayerState.map((d, idx) => (
            <React.Fragment key={idx}>
              <ExpandMoreCheckBox
                label={d.title}
                showMore={d.values.length}
                onClickShowMore={() => {
                  if (d.title === "Highways") {
                    if (!showHighwayStyle) {
                      setLayoutVisibility(
                        d.values.flatMap((d) => d.id),
                        true
                      );
                    }
                    setShowHighwayStyle(true);
                    // changeSetting();
                  } else {
                    toggleShowMore(d.title, setMapRoadLayerState);
                  }
                }}
                dataVisible={d.showMore}
                onCheckClick={(e) => {
                  if (d.title === "Highways") {
                    setShowHighwayStyle(e.target.checked);
                  }
                  enableParent(d.values);
                }}
                checked={d.values
                  .flatMap((d) => d.id)
                  .every((d) => selectedLayers.includes(d))}
                disabled={d.disable}
              />
              {d.values.length && d.showMore && (
                <Box
                  sx={{
                    pl: "1vw",
                    borderLeft: "1px solid white",
                    borderRadius: "4px",
                  }}
                >
                  {d.values.map((v, i) => (
                    <ExpandMoreCheckBox
                      key={i}
                      label={v.title}
                      showMore={v.values?.length}
                      onCheckClick={() => enableChild(v.id)}
                      checked={selectedLayers.includes(v.id)}
                      disabled={v.disable}
                    />
                  ))}
                </Box>
              )}
            </React.Fragment>
          ))}
        </Box>
      )}
      <ExpandMoreCheckBox
        label="Map Features"
        showMore={true}
        dataVisible={showMoreMapFeatures}
        onClickShowMore={toggleMapFeatures}
        onCheckClick={showMapFeatures}
        checked={mapFeatures.every((d) => selectedLayers.includes(d))}
      />
      {showMoreMapFeatures && (
        <Box
          sx={{
            pl: "0.5vw",
            display: "flex",
            flexDirection: "column",
            gap: "1vh",
            borderLeft: "1px solid white",
            borderRadius: "4px",
            maxHeight: "200px",
            overflow: "auto",
          }}
        >
          {mapFeatureLayerState.map((d, idx) => (
            <React.Fragment key={idx}>
              <ExpandMoreCheckBox
                label={d.title}
                showMore={d.values.length}
                onClickShowMore={() =>
                  toggleShowMore(d.title, setMapFeatureLayerState)
                }
                onCheckClick={() => enableParent(d.values)}
                dataVisible={d.showMore}
                checked={d.values
                  .flatMap((d) => d.id)
                  .every((d) => selectedLayers.includes(d))}
                disabled={d.disable}
              />
              {d.values.length && d.showMore && (
                <Box
                  sx={{
                    pl: "0.5vw",
                    borderLeft: "1px solid white",
                    borderRadius: "4px",
                  }}
                >
                  {d.values.map((v, i) => (
                    <ExpandMoreCheckBox
                      key={i}
                      label={v.title}
                      showMore={v.values?.length}
                      onCheckClick={() => enableChild(v.id)}
                      checked={selectedLayers.includes(v.id)}
                      disabled={v.disable}
                    />
                  ))}
                </Box>
              )}
            </React.Fragment>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default AdditionalLayers;
